// extracted by mini-css-extract-plugin
module.exports = {"main":"home_main__2kLrC","scroller":"home_scroller__xslb-","exhibits":"home_exhibits__2EnPY","exhibitsRitual":"home_exhibitsRitual__3DqOE","contact":"home_contact__GL4Q8"};